module.exports = __webpack_public_path__ + "img/contentful.7f9654aa.png";